export const AlertTypeEnum = [
    { title: 'All', value: '' },
    { title: 'Expiring Credit Card', value: 1 },
    { title: 'New Lead Received', value: 2 },
    { title: 'Submission Added', value: 3 },
    { title: 'Submission Updated', value: 4 },
    { title: 'Aging Transaction', value: 5 },
    { title: 'Failed Transaction', value: 6 },
    { title: 'Denied/Declined Transaction', value: 7 },
]